export default "__VITE_ASSET__CdpuM25A__"